module.exports = __webpack_public_path__ + "static/media/gcpblog.3bfb05bc.png";